import type { PanelType } from '@/types';
import { store } from '@/state';
import { showToast } from './toast';

/** Panel transition delay in milliseconds */
const TRANSITION_DELAY = 350;

/**
 * Toggle a panel's visibility
 * @param panel - Panel type to toggle
 */
export function togglePanel(panel: PanelType): void {
  const missionControl = document.getElementById('mission-control');
  if (!missionControl) return;

  const className = `${panel}-collapsed`;
  const wasCollapsed = missionControl.classList.contains(className);
  missionControl.classList.toggle(className);

  // Resize globe after panel transition
  setTimeout(() => {
    const globe = store.get('globe');
    if (globe) {
      const container = document.querySelector('.globe-container') as HTMLElement;
      if (container) {
        globe.width(container.clientWidth);
        globe.height(container.clientHeight);
      }
    }
  }, TRANSITION_DELAY);

  // Show toast notification
  const panelNames: Record<string, string> = {
    left: 'Panel',
    bottom: 'Live Feed',
  };
  const panelName = panelNames[panel] ?? panel.charAt(0).toUpperCase() + panel.slice(1);
  const state = wasCollapsed ? 'shown' : 'hidden';
  showToast(`${panelName} ${state}`);
}

/**
 * Check if a panel is collapsed
 * @param panel - Panel type to check
 * @returns True if panel is collapsed
 */
export function isPanelCollapsed(panel: PanelType): boolean {
  const missionControl = document.getElementById('mission-control');
  if (!missionControl) return false;

  return missionControl.classList.contains(`${panel}-collapsed`);
}

/**
 * Set panel visibility
 * @param panel - Panel type
 * @param visible - Whether panel should be visible
 */
export function setPanelVisible(panel: PanelType, visible: boolean): void {
  const isCollapsed = isPanelCollapsed(panel);
  if ((visible && isCollapsed) || (!visible && !isCollapsed)) {
    togglePanel(panel);
  }
}
